import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getMetadataCounts } from "../../../services/metadataService";
import NormalAlert from "../../AlertComponent/NormalAlert";
import { GetEmployeeName } from "../../../services/authService";
import Cookies from "js-cookie";
import "./MasterData.css";


const MasterData = () => {
  const navigate = useNavigate();

  const [metadataCounts, setMetadataCounts] = useState({
    functionCount: 0,
    gradeCount: 0,
    zoneCount: 0,
    departmentCount: 0,
    jobLocationCount: 0,
    roleTypeCount: 0,
    jobCategoryCount: 0,
  });

  const [loading, setLoading] = useState(true);
  const [alert, setAlert] = useState(null);

  useEffect(() => {
    const fetchCounts = async () => {
      try {
        const result = await getMetadataCounts();
        if (result && result.length > 0) setMetadataCounts(result[0]);
      } catch (error) {
        const safeMessage =
          error?.response?.data?.message ||
          "Something went wrong. Please try again.";

        setAlert({
          type: "fail",
          message: safeMessage,
        });
      } finally {
        setLoading(false);
      }
    };

    fetchCounts();
  }, []);

  const handleCardClick = (type) => {
    navigate(`/Dashboard/Master-Data/${type}`);
  };

  const cards = [
    {
      title: "Functions",
      type: "Functions",
      count: metadataCounts.functionCount,
      icon: "bi-diagram-3",
    },
    {
      title: "Grades",
      type: "Grades",
      count: metadataCounts.gradeCount,
      icon: "bi-bar-chart-steps",
    },
    {
      title: "Zones",
      type: "Zones",
      count: metadataCounts.zoneCount,
      icon: "bi-geo-alt",
    },
    {
      title: "Departments",
      type: "Departments",
      count: metadataCounts.departmentCount,
      icon: "bi-building",
    },
    {
      title: "Job Locations",
      type: "Job-Locations",
      count: metadataCounts.jobLocationCount,
      icon: "bi-geo-fill",
    },
    {
      title: "Role Types",
      type: "Role-Type",
      count: metadataCounts.roleTypeCount,
      icon: "bi-person-badge",
    },
    {
      title: "Job Categories",
      type: "Job-Category",
      count: metadataCounts.jobCategoryCount,
      icon: "bi-briefcase",
    },
  ];

   useEffect(() => {
    const checkRole = async () => {
      const token = Cookies.get("employeeToken");
      
      if (!token) {
        navigate("/");
        return;
      }
  
      try {
        const response = await GetEmployeeName(token);
        const userRole = response?.data?.employeeRole;
  
        if (userRole !== "Admin Employee") {
          navigate("/Dashboard");
        }
      } catch (err) {
        navigate("/Dashboard"); 
      }
    };
  
    checkRole();
  }, []);

  return (
    <>
      <div className="container py-5 mt-5">
        <h3 className="text-primary mb-4 text-center fw-bold">
          Master Data Overview
        </h3>

        {loading ? (
          <div className="text-center mt-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-3">Loading Master Data...</p>
          </div>
        ) : (
          <div className="row g-4">
            {cards.map((card, index) => (
              <div className="col-12 col-sm-6 col-md-4 col-lg-3" key={index}>
                <div
                  className="card shadow-sm text-center p-4 hover-card"
                  onClick={() => handleCardClick(card.type)}
                  style={{ cursor: "pointer" }}
                >
                  <div className="mb-3">
                    <i className={`bi ${card.icon} fs-1 text-primary`}></i>
                  </div>
                  <h5 className="fw-semibold">{card.title}</h5>
                  <h3 className="text-dark fw-bold">{card.count}</h3>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      {alert && (
        <NormalAlert
          type={alert.type}
          message={alert.message}
          onClose={() => setAlert(null)}
        />
      )}
    </>
  );
};

export default MasterData;
